import { create } from 'zustand';

export type CartActionToastAction = 'added' | 'removed';

interface CartActionToastState {
  /**
   * The most recent cart add/remove to surface as a toast, or null when none is
   * showing. `nonce` changes on every trigger so the toast re-animates and
   * resets its auto-dismiss timer even when the same action fires twice.
   */
  cartActionToast: { action: CartActionToastAction; nonce: number } | null;
}

interface CartActionToastStore extends CartActionToastState {
  showCartActionToast: (action: CartActionToastAction) => void;
  dismissCartActionToast: () => void;
}

/**
 * Drives the Exp 242 "added/removed to cart → total credits" toast that appears
 * above the floating bottom nav on the home and search surfaces. The trigger is
 * fired from `useShopActions` (gated to mobile + Exp 242 + those routes) and the
 * toast overlay subscribes here.
 */
export const useCartActionToastStore = create<CartActionToastStore>((set) => ({
  cartActionToast: null,
  showCartActionToast: (action) =>
    set({ cartActionToast: { action, nonce: Date.now() } }),
  dismissCartActionToast: () => set({ cartActionToast: null }),
}));
